import React, { useCallback, useMemo } from 'react';
import type { SetSelectedCreatives } from 'c-main/Components/CreativeManagement/types';
import { Checkbox, FileBrowserSelectState } from 'c-components';
import {
    selectAllState as getSelectAllState,
    selectionAfterSelectAll,
} from '../../creativeGroupLogic';

type Props = {
    selectedCreatives: number[];
    setSelectedCreatives: SetSelectedCreatives;
    visibleCreatives: number[];
};

const CreativesSelectAll: React.FC<Props> = ({
    selectedCreatives,
    setSelectedCreatives,
    visibleCreatives,
}) => {
    const selectAllState = useMemo(
        () => getSelectAllState(selectedCreatives, visibleCreatives),
        [selectedCreatives, visibleCreatives],
    );

    const onSelectAllToggle = useCallback(() => {
        setSelectedCreatives(selectionAfterSelectAll(selectedCreatives, visibleCreatives));
    }, [selectedCreatives, setSelectedCreatives, visibleCreatives]);

    return (
        <Checkbox
            onClick={onSelectAllToggle}
            checked={selectAllState === FileBrowserSelectState.Checked}
            indeterminate={selectAllState === FileBrowserSelectState.Indeterminate}
            label=""
            className="creatives-select-all"
            formControlLabelSx={{ mr: 0 }}
        />
    );
};

export default CreativesSelectAll;
